// Icons from the Sync Schedule prototype (COM-491).
import React from 'react';

const S = {
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const Mic = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="9" y="2" width="6" height="11" rx="3" fill="currentColor" />
    <path d="M5.5 11.2a6.5 6.5 0 0 0 13 0M12 17.7V21" {...S} strokeWidth="2" />
  </svg>
);

export const MicAdd = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">
    <rect
      x="6.6"
      y="2.4"
      width="5.4"
      height="9.8"
      rx="2.7"
      fill="currentColor"
    />
    <path
      d="M3.6 10.6a5.7 5.7 0 0 0 11.4 0M9.3 16.3V19.4"
      {...S}
      strokeWidth="2"
    />
    <path d="M19 13.4v7.2M15.4 17h7.2" {...S} strokeWidth="2.4" />
  </svg>
);

export const Stop = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="6" y="6" width="12" height="12" rx="2.5" fill="currentColor" />
  </svg>
);

const STAR_BIG =
  'M18.1 1.6Q18.9 5.6 22.9 6.4Q18.9 7.2 18.1 11.2Q17.3 7.2 13.3 6.4Q17.3 5.6 18.1 1.6Z';
const STAR_SM =
  'M21.3 12.2Q21.72 14.28 23.8 14.7Q21.72 15.12 21.3 17.2Q20.88 15.12 18.8 14.7Q20.88 14.28 21.3 12.2Z';
export const Spark = () => (
  <svg width="21" height="21" viewBox="0 0 24 24" aria-hidden="true">
    <rect
      x="2.4"
      y="3.9"
      width="11.2"
      height="17.2"
      rx="2.2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
    />
    <path
      d="M5.3 9.6h5.4M5.3 13.1h5.4M5.3 16.6h3.1"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d={STAR_BIG}
      fill="none"
      stroke="var(--ko,#fff)"
      strokeWidth="2.3"
      strokeLinejoin="round"
    />
    <path d={STAR_BIG} fill="currentColor" />
    <path
      d={STAR_SM}
      fill="none"
      stroke="var(--ko,#fff)"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <path d={STAR_SM} fill="currentColor" />
  </svg>
);

export const Dots = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="5" r="1.9" fill="currentColor" />
    <circle cx="12" cy="12" r="1.9" fill="currentColor" />
    <circle cx="12" cy="19" r="1.9" fill="currentColor" />
  </svg>
);

export const Grip = () => (
  <svg width="14" height="16" viewBox="0 0 14 16" aria-hidden="true">
    {[3, 8, 13].map((y) => (
      <React.Fragment key={y}>
        <circle cx="4" cy={y} r="1.5" fill="currentColor" />
        <circle cx="10" cy={y} r="1.5" fill="currentColor" />
      </React.Fragment>
    ))}
  </svg>
);

export const Check = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="11" fill="currentColor" />
    <path
      d="M6.8 12.4l3.3 3.3 7.1-7.4"
      fill="none"
      stroke="#fff"
      strokeWidth="3.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Chev = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" {...S} strokeWidth="2.6">
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const People = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" {...S} strokeWidth="2">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const Trash = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" {...S} strokeWidth="2">
    <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" />
  </svg>
);

export const Move = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" {...S} strokeWidth="2.2">
    <path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4" />
  </svg>
);

export const Open = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" {...S} strokeWidth="2.2">
    <path d="m9 18 6-6-6-6" />
  </svg>
);

export const Jump = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" {...S} strokeWidth="2.6">
    <path d="m11 17-5-5 5-5M18 17l-5-5 5-5" />
  </svg>
);

export const Caret = () => (
  <svg
    className="vs-dcaret"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    {...S}
    strokeWidth="3"
    aria-hidden="true"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const SyncIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" {...S} strokeWidth="2.2">
    <path d="M21 3v6h-6" />
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
    <path d="M3 21v-6h6" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
  </svg>
);

// With `level` (0–1) the bars follow the mic; without it they animate.
const EQ_SHAPE = [0.55, 1, 0.75, 0.45];
export const Eq = ({ small, level }) => (
  <span
    className={`vs-eq${small ? ' vs-sm' : ''}${level !== undefined ? ' vs-live-eq' : ''}`}
    aria-hidden="true"
  >
    {EQ_SHAPE.map((k, i) => (
      <i
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        style={
          level !== undefined
            ? {
                transform: `scaleY(${Math.max(0.15, Math.min(1, level * k * 1.6))})`,
              }
            : undefined
        }
      />
    ))}
  </span>
);

export const CalPlus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    {...S}
    strokeWidth="2.1"
    aria-hidden="true"
  >
    <rect x="3" y="4.5" width="18" height="16.5" rx="2.5" />
    <path d="M16 2.5v4M8 2.5v4M3 10h18M12 13.2v5M9.5 15.7h5" />
  </svg>
);

export const Pencil = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" {...S} strokeWidth="2.4">
    <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

export const Photo = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    {...S}
    strokeWidth="2"
    aria-hidden="true"
  >
    <rect x="3" y="4" width="18" height="16" rx="2.5" />
    <circle cx="9" cy="10" r="1.8" />
    <path d="m21 16-5-5-9 9" />
  </svg>
);

export const Density = ({ spacious }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    {...S}
    strokeWidth="2.2"
    aria-hidden="true"
  >
    <path
      d={
        spacious ? 'M4 6h16M4 12h16M4 18h16' : 'M4 5h16M4 10h16M4 15h16M4 20h16'
      }
    />
  </svg>
);
